import React, { useContext } from 'react';
import PreviewNavigation from '../components/PreviewNavigation';
import {
  DynamicQuestionsContext,
  TYPES,
} from 'chameleon/packages/blue-book-player/state/DynamicQuestionContext';

const withPreviewNavigation = (WrapperComponent) => {
  const BlueBookQuestionNavigation = (props) => {
    const { state, dispatch } = useContext(DynamicQuestionsContext);
    const onItemGoTo = (questionsApi) => {
      dispatch({
        type: TYPES.ADD_ALL_QUESTION_KEYS,
        payload: Object.keys(questionsApi),
      });
      const questionsApiDiff = Object.keys(questionsApi).filter(
        (q) => !state.allQuestionKeys.includes(q),
      );
      dispatch({
        type: TYPES.ADD_CURRENT_QUESTION_KEYS,
        payload: questionsApiDiff,
      });
    };

    return (
      <WrapperComponent
        {...props}
        render={(data) => {
          const { learnosityApp, learnosityItems, onItemChange } = data;
          const { location, router, params, previewData } = props;

          const onUrlUpdate = (itemId) => {
            dispatch({
              type: TYPES.ADD_CURRENT_ITEM_ID,
              payload: itemId,
            });
          };

          const previewNavigationProps = {
            learnosityData: { app: learnosityApp, items: learnosityItems },
            location,
            router,
            params: { ...params, previewId: previewData.itemId },
            onItemChange,
            ...previewData,
          };
          if (learnosityApp) {
            return (
              <PreviewNavigation
                onItemGoTo={onItemGoTo}
                onUrlUpdate={onUrlUpdate}
                {...previewNavigationProps}
              />
            );
          }
        }}
      />
    );
  };

  return BlueBookQuestionNavigation;
};

export default withPreviewNavigation;
